import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class PhotoAlbumService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetPhotoAlbum():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/PhotoAlbum/Get`);
  }

  DeletePhotoAlbum(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/PhotoAlbum/Delete?id=${id}`);
  }

  CreatePhotoAlbum(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/PhotoAlbum/Create`,data);
  }
  UpdatePhotoAlbum(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/PhotoAlbum/Update`,data)
  }
}
